export default __webpack_public_path__ + "static/media/DeleteInventory.78a53058.svg";